import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import Home from "./pages/home";
import Admin from "./pages/admin";
import Sorteios from "./pages/sorteios";
import Login from "./pages/login";
import { logout, getUser as getUserService } from "./services/auth.js";

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Root não encontrado");

const root = ReactDOM.createRoot(rootEl);

function renderPage(page) {
  let PageComponent = null;

  if (page === "home") PageComponent = Home;
  if (page === "admin") PageComponent = Admin;
  if (page === "sorteios") PageComponent = Sorteios;
  if (page === "login") PageComponent = Login;

  if (!PageComponent) {
    throw new Error("Página não definida");
  }

  root.render(<PageComponent />);
}

function navigateToRequestedPage() {
  const hash = window.location.hash.slice(1);
  const page = hash || document.body.dataset.page || "login";
  const user = getUserService();

  if (!user && page !== "login") {
    logout();
    window.location.hash = "login";
    return renderPage("login");
  }

  if (user && page === "admin" && user.role !== "admin") {
    window.location.hash = "home";
    return renderPage("home");
  }

  renderPage(page);
  updateNav(); // Update nav after page render
}

// Update navigation menu based on user role
function updateNav() {
  const user = getUserService();
  const nav = document.getElementById("nav-menu");

  if (!nav) return;

  // Remove old admin/sorteios links
  const oldAdminLink = nav.querySelector("a[href='#admin']");
  const oldSorteiosLink = nav.querySelector("a[href='#sorteios']");
  if (oldAdminLink) oldAdminLink.remove();
  if (oldSorteiosLink) oldSorteiosLink.remove();

  // Add or remove links based on role
  if (user && user.role === "admin") {
    const adminLink = document.createElement("a");
    adminLink.href = "#admin";
    adminLink.onclick = () => {
      window.location.hash = "#admin";
    };
    adminLink.textContent = "Admin";
    nav.appendChild(adminLink);

    const sorteiosLink = document.createElement("a");
    sorteiosLink.href = "#sorteios";
    sorteiosLink.onclick = () => {
      window.location.hash = "#sorteios";
    };
    sorteiosLink.textContent = "Sorteios";
    nav.appendChild(sorteiosLink);
  }
}

// Add a persistent top-left logout button (DOM-based) so it is available outside React
function ensureLogoutButton() {
  let btn = document.getElementById("global-logout-btn");
  if (!btn) {
    btn = document.createElement("button");
    btn.id = "global-logout-btn";
    btn.style.position = "fixed";
    btn.style.right = "8px";
    btn.style.top = "8px";
    btn.style.zIndex = 2000;
    btn.style.padding = "0.4rem 0.6rem";
    btn.style.borderRadius = "4px";
    btn.style.background = "#e74c3c";
    btn.style.color = "white";
    btn.style.border = "none";
    btn.style.cursor = "pointer";
    btn.innerText = "Sair";
    btn.onclick = () => {
      logout();
      window.location.hash = "login";
    };
    document.body.appendChild(btn);
  }

  // show or hide based on auth
  const user = getUserService();
  btn.style.display = user ? "block" : "none";
}

document.addEventListener("DOMContentLoaded", () => {
  ensureLogoutButton();
  updateNav();
});

// Inicializa o primeiro render
// Inicializa o primeiro render e navega nas mudanças do hash
document.addEventListener("DOMContentLoaded", navigateToRequestedPage);
window.addEventListener("hashchange", () => {
  document.body.dataset.page = window.location.hash.slice(1);
  navigateToRequestedPage();
});
